/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M99.65,0C70.5,0,55.3,13.76,47.29,42.3L1.1,205.73c-3.7,13.34,2,22,15.8,22H236.6C265.76,227.7,281,214,289,185.4L335.15,22c3.7-13.35-2-22-15.81-22ZM147.9,79.05c0-2.47-.82-3.7-3.49-3.7-2.26,0-3.08,1-3.91,3.7l-23.4,83.56c-4.93,17.66-10.67,24-30.18,24H73c-4.53,0-5.75-2.46-4.32-7.39L99.24,73.92c7.19-24.85,17-36.54,51.74-36.54,24.23,0,35.31,5.74,35.93,36.12l1.44,74.75c0,2.45.81,3.68,3.48,3.68,2.26,0,3.08-1,3.91-3.68l23.4-83.58c4.92-17.65,10.69-24,30.19-24h14c4.52,0,5.74,2.47,4.32,7.4L237,153.38c-7.18,24.84-16.83,36.55-51.33,36.55-24.64,0-35.73-5.76-36.35-36.15Z"
}), 'LogoNetshoesRounded', {
  viewBox: '0 0 336.25 227.7',
  fill: '#5A2D82'
});